import { useRef, useState } from 'react'
import Swiper from 'swiper'
import { SlideProps } from './styled'

export type SliderProps = SlideProps & {
  slides: Array<{
    src: string
    title: string
    description?: string
    note?: string
    link?: string
    overlayText?: string
  }>
  overlayOnlyOnHover?: boolean
  capitalizeDescription?: boolean
}

export const useSlider = (slides: SliderProps['slides']) => {
  const swiper = useRef<Swiper>()
  const [slideIndex, setSlideIndex] = useState(0)
  const [openImageUrl, setOpenImageUrl] = useState('')
  const slide = slides[slideIndex]

  return {
    swiper,
    slideIndex,
    setSlideIndex,
    openImageUrl,
    setOpenImageUrl,
    slide,
  }
}
